import FactoringCompanies from "./FactoringCompanies";

export default FactoringCompanies;
